export const PulseMark = ({ className = "h-9 w-auto" }) => (
  <svg viewBox="0 0 44 52" fill="none" className={className} aria-hidden="true">
    <circle cx="32" cy="9" r="6" fill="#F7941D" />
    <path d="M32 19v28" stroke="#F7941D" strokeWidth="7" strokeLinecap="round" />
    <path
      d="M4 36h10l4.5-12 7 21 4.5-9h9"
      stroke="#F7941D"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Logo = ({ light = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label="AccuSurge Medical Solutions Pvt. Ltd.">
    <PulseMark className="h-8 w-auto md:h-9" />
    <span className="flex flex-col leading-none">
      <span
        className={`font-heading text-xl md:text-2xl font-extrabold tracking-tight ${light ? "text-white" : "text-brand-700"}`}
      >
        ACCUSURGE
      </span>
      <span className="mt-1 font-mono text-[9px] md:text-[10px] font-medium uppercase tracking-[0.32em] text-accent">
        Medical Solutions
      </span>
    </span>
  </span>
);

export default Logo;
